<template lang="html">
  <div class="newVip">
    <common-header></common-header>
    <div class="imgContainer">
    	<div><img src="../../../assets/img/aboutUsKv.png" /></div>
    </div>
    <div class="newContainer">
    	<div class="usTab">新手须知
    		<img src="../../../assets/img/aboutUsTag.png" />
    	</div>
    	<div class="contentBox">
    		<div class="title">新手须知</div>
    		<div class="eng-title">什么是君弘积分？</div>
    		<div class="abstract">
    			为感谢君弘财富俱乐部会员对国泰君安证券的一贯支持，君弘俱乐部推出了君弘会员积分亲情回馈我们的会员。会员可以通过入会、交易、参加营销活动等多种方式获取积分，所获积分可以兑换国泰君安自有服务产品以及第三方服务产品。</div>
    	</div>
    	<div class="contentBox">
    		<div class="title">如何获取积分</div>
    		<div class="eng-title">什么是君弘积分？</div>
    		<div class="abstract">
    			<p>
					一.参与资格</br>
					　　您只要成为国泰君安证券君弘财富俱乐部银卡及以上会员，就可以参与君弘俱乐部会员积分活动，获得相应积分。</br>
					二.积分组成</br>
					　　您的积分由奖励积分和交易积分两部分组成。</br>
					　　奖励积分</br>
					　　您参加君弘财富俱乐部举办的各种积分活动就可以获得奖励积分，具体的活动规则及奖励标准以最新</br>
					的活动公告为准。</br>
					　　交易积分</br>
					  会员在国泰君安证券进行沪深证券交易所以下品种的买卖交易，可获得交易积分，其中交易积分计算公式为：交易积分=成交金额*品种系数*客户系数</br>
					  1）股票，包括A股和B股</br>
					  2）ETF</br>
					  3）封闭式基金</br>
					  4）LOF</br>
					  5) 融资融券</br>
					  6）股票期权</br>
					  7）其他在交易所挂牌交易的品种</br>
					  8）公司认定的其他相关品种。</br>
					　　各品种积分计算方式请详见表1，君弘财富俱乐部保留调整各品种积分计算方式的权利。</br>
				</p>
				<table>
					<tr class="headTr">
						<th class="th1">交易品种</th>
						<th class="th2">品种系数</th>
						<th class="th3">标准积分</th>
					</tr>
					<tr>
						<td>A股</td>
						<td>0.56%</td>
						<td>每10000成交金额，获得标准积分56分</td>
					</tr>
					<tr>
						<td>B股</td>
						<td>0.56%</td>
						<td>每10000成交金额，获得标准积分56分</td>
					</tr>
					<tr>
						<td>封闭式股</td>
						<td>0.56%</td>
						<td>每10000成交金额，获得标准积分56分</td>
					</tr>
					<tr>
						<td>LOF</td>
						<td>0.56%</td>
						<td>每10000成交金额，获得标准积分56分</td>
					</tr>
					<tr>
						<td>ETF</td>
						<td>0.10%</td>
						<td>每10000成交金额，获得标准积分10分</td>
					</tr>
					<tr>
						<td>融资融券</td>
						<td>0.56%</td>
						<td>每10000成交金额，获得标准积分56分</td>
					</tr>
					<tr>
						<td>股票期权</td>
						<td>0.10%</td>
						<td>每10000成交金额，获得标准积分10分</td>
					</tr>
					<tr>
						<td colspan="3">
							<span>注1：其中B股依据人民银行每月末公布的外汇表折算为人民币成交金额；</span></br>
							<span>注2：标准积分是按照客户标准佣金率计算生成的示例积分；</span></br>
							<span>注3：客户积分由标准积分按照客户系数换算生成，其中客户系数根据客户价值贡献自动生成。</span></br>
						</td>
					</tr>
				</table>
				<p>
					三.积分有效期</br>
					　　君弘积分原则上1年有效，按年滚动清零。</br>
					四.积分使用、转移</br>
					　　您的积分仅限您本人使用，不得转让、赠送。</br>
					五.积分查询</br>
					　　您可以通过以下两种方式查询积分：</br>
					　　1. 登录君弘财富俱乐部网站（http://www.junhongclub.com）。</br>
					　　2. 拨打国泰君安证券客服热线（95521）。</br>
					　　交易积分按月累积，您可以于每月10日上午9点以后查询上月入账积分。</br>
					六.积分兑换</br>
					　　您自入会次日起享有兑换资格。积分兑换遵循“先到期积分先兑换原则”。</br>
					您可以通过登录君弘APP会员专属服务模块或者君弘财富俱乐部网站（http://www.junhongclub.com）进行积分兑换。
					七.积分礼品</br>
					　　1．礼品兑换仅限您本人提出申请，申请一经君弘财富俱乐部接受，即不可取消或更改，君弘财富俱乐部将根据提交的礼品兑换申请扣减会员相应积分。 </br>
					　　2、各积分礼品、兑换标准及兑换规则以兑换当时最新活动公告为准。 </br>
					　　3．各宣传途径所列积分礼品图样仅供参考，以实物为准。</br> 
					　　4．部分积分礼品兑换数量有限，先兑先得，兑完为止；君弘财富俱乐部保留调整备选礼品而不做预先通知的权利。 </br>
					　　5．兑换成功的礼品，如需配送，将按会员兑换申请中填写的地址(仅限大陆地区，其余地区邮费自理)配送。</br>
					　　6. 会员的参与资格被取消后，则该会员没有实施兑换申请的积分将不再获得受理。</br>
					八.其他重要申明</br>
					　　会员积分仅适用于本规则范围，在兑换取得积分礼品之前并不构成会员资产；积分也不可转让给其他会员或任何第三人，任何转让对君弘财富俱乐部均不产生效力。</br> 
					　　因所兑换的积分礼品而发生的相应所得税均由会员自行申报和承担。 </br>
					　　君弘财富俱乐部在法律允许的范围内保留对本积分活动及规则作出最终解释的权利，并有权根据需要随时增删、修订本规则。 </br>
					　　本规则自发布之日起开始实施。</br>
				</p>
			</div>
    	</div>
    	<div class="contentBox">
    		<div class="title">如何兑换君弘积分</div>
    		<div class="eng-title">一、兑换渠道</div>
    		<div class="abstract">
				目前会员可通过登录君弘网站：www.junhongclub.com 进入“积分商城”进行积分兑换，未来我们将开通营业部现场兑换渠道以及95521客服热线兑换渠道。</div>
			<div class="eng-title">二、兑换流程</div>
    		<div class="abstract">
				进入积分商城（查看商城中的服务或产品）→积分兑换（选择兑换礼品）→填写兑换信息（兑换服务或产品的期限、数量，若为实物产品需填写发货信息）→兑换成功，扣减积分→回到积分商城，继续浏览。</div>
    	</div>
    	<div class="contentBox">
    		<div class="title">免责条款</div>
    		<div class="eng-title">一、积分免责条款</div>
    		<div class="abstract">
				国泰君安证券君弘积分兑换所提供的各项回馈项目除国泰君安证券自己的产品和服务外，涉及到的第三方产品和服务均由该产品/服务供应商直接提供予君弘会员，国泰君安证券与供应商间并无合伙、经销、代理关系、广告媒体或保证人关系；如会员与供应商所提供的回馈产品或服务及售后服务有争议时，概由各供应商负责。国泰君安证券不承担任何责任。</div>
			<div class="eng-title">二、国泰君安解释权</div>
    		<div class="abstract">
				国泰君安证券君弘俱乐部保留对本积分计划办法中条款解释的权利，并有权根据需要取消本计划或增删、修订本规定的权利（包括但不限于参加资格、积分计算、兑换产品及兑换标准），并于国泰君安证券相关媒体（如公司网站、电子对账单等）、报纸或者各分支营业网点公告后生效。</div>
    	</div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
	import commonHeader from '../../../components/common/commonHeader'
	import commonFooter from '../../../components/common/commonFooter'
	import listKv from '../../../components/common/listKv'
	//接口
	import Server from '../../../server/server.js'
	export default {
	  	data(){
		  	return{
		  		items:[]
		  	}
	  	},
	  	components:{
	  		commonHeader,
	  		commonFooter,
	  		listKv,
	  	},
	  	created(){
	  		//
	  	},
	}
</script>

<style lang="less" scoped>
	.newVip{
		.imgContainer{
			padding:0px 40px;
			width:100%;
			margin-top:150px;
			div{
				width:100%;
				border-radius:10px;
				overflow:hidden;
				img{
					width:100%;	
					height:340px;
				}
			}
		}
		.newContainer{
			width:100%;
			margin-top:30px;
			padding:0 40px;
			.usTab{
				width:100%;
				height:80px;
				padding:0 30px;
				line-height:80px;
				background-image:linear-gradient(90deg, #f1e3bb 0%, #e0c385 100%);
				border-radius:10px;
				text-align:left;
				color:#ad8f5a;
				font-size:28px;
				img{
					width:32px;
					float:right;
					margin-top:24px;
				}
			}
			.contentBox{
				width:100%;
				margin-top:30px;
				text-align:left;
				.title{
					font-size:32px;
					color:#ad8f5a;
					letter-spacing:0;
					line-height:52px;
				}
				.eng-title{
					margin-top:10px;
					font-size:28px;
					color:#818181;
					letter-spacing:0;
					line-height:28px;
				}
				.abstract{
					margin-top:20px;
					font-size:28px;
					color:#000000;
					letter-spacing:0.07px;
					line-height:50px;
					table{
						border: 1px solid #ddd;
						border-collapse: collapse;
						.headTr{	
						    border: 1px solid #e4d1a7;
						    border-top-left-radius: 10px;
						    border-top-right-radius: 10px;
						    th{
							    background: #e4d1a7;
							    font-size: 32px;
							    color: #ad8f5a;
							    letter-spacing: 0;
							    line-height: 64px;
							    border: none;
							    padding-left: 20px;
							    font-weight: 400;
							    height:100px;
						    }
						    .th1{
						    	width:25%;
						    }
						    .th2{
						    	width:25%;
						    }
						    .th3{
						    	width:50%;
						    }

						}
						td{
					    	padding: 10px 20px;
					    	border: 1px solid #ddd;
					    }
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/container/aboutUsPage/aboutUs/newVip.vue